import { PasswordLevelVerificationRules } from '@/config/default'
import intl from 'react-intl-universal'

/**
 * 获取密码校验规则列表（含 min/max 自定义长度覆盖）
 * @param {string} passwordLevel - 密码安全等级: 'LOW' | 'MEDIUM' | 'HIGH'
 * @param {number} [min] - 自定义最小长度
 * @param {number} [max] - 自定义最大长度
 * @returns {Array<{id: number, label: string, validate: (value: string) => boolean}>}
 */
export const getPasswordRules = (passwordLevel, min, max) => {
  const rules = passwordLevel && PasswordLevelVerificationRules[passwordLevel]
  if (!rules) return []

  return rules.map(rule => {
    if (min && max && rule.id === 1) {
      return {
        ...rule,
        label: intl.get('login.psdLength', { min, max }),
        validate: (val) => {
          const reg = new RegExp(`^.{${min},${max}}$`)
          return reg.test(val)
        }
      }
    }
    return { ...rule }
  })
}

/**
 * 校验密码，返回第一条未通过规则的 label；全部通过返回 null
 * @param {string} value - 密码值
 * @param {string} passwordLevel - 密码安全等级
 * @param {number} [min] - 自定义最小长度
 * @param {number} [max] - 自定义最大长度
 * @returns {string | null} 第一条未通过规则的错误信息，全部通过则返回 null
 */
export const getPasswordFirstError = (value, passwordLevel, min, max) => {
  if (!value) return null

  const rules = getPasswordRules(passwordLevel, min, max)
  for (const rule of rules) {
    if (!rule.validate(value)) {
      return rule.label
    }
  }
  return null
}
